<script>
import TransitionExpand from '@/components/shared/TransitionExpand.vue';
import MenuItemExternal from './MenuItemExternal.vue';

export default {
  name: 'MenuItem',

  components: {
    MenuItemExternal,
    TransitionExpand,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    level: {
      type: Number,
      required: true,
    },

    parentPath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isMenuOpen: true,
      subMenu: this.item.fields.subMenu,
    };
  },

  computed: {
    pageLink() {
      return this.item.fields.link.fields && this.item.fields.link.fields.slug
        ? this.item.fields.link
        : undefined;
    },

    externalLink() {
      return this.item.fields.link.fields && this.item.fields.link.fields.url;
    },

    slug() {
      return this.pageLink && this.pageLink.fields ? this.pageLink.fields.slug : '';
    },

    path() {
      return `${this.parentPath}/${this.slug}`;
    },

    showOverviewPage() {
      return this.pageLink && this.pageLink.fields.hasOverviewPage;
    },

    urlItems() {
      return this.$route.path.replace('/', '').split('/');
    },

    isActive() {
      return this.pageLink ? this.urlItems[this.level] === this.slug : false;
    },

    isExact() {
      return this.isActive && this.$route.path.split('/').reverse()[0] === this.slug;
    },
  },

  watch: {
    $route() {
      this.closeTopLevelMenu();
    },
  },

  methods: {
    closeTopLevelMenu() {
      if (this.urlItems.length > 1 && this.urlItems[0] !== this.slug) {
        this.isMenuOpen = false;
      }
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    checkIfOpen() {
      return this.level === 0 ? this.isMenuOpen : this.isActive;
    },
  },
};
</script>

<template>
  <div>
    <MenuItemExternal v-if="externalLink" :item="item" :level="level" />

    <template v-else>
      <button
        v-if="subMenu && level === 0"
        class="level-0"
        :class="{ active: isActive }"
        @click="toggleMenu()"
      >
        {{ item.fields.heading }}

        <img
          src="@/assets/svg-icons/chevron-up.svg"
          class="icon toggle"
          :class="{ collapsed: !isMenuOpen }"
          width="16"
          height="16"
        />
      </button>

      <router-link v-else :to="path" :class="[`level-${level}`, { active: isActive }]">
        {{ item.fields.heading }}
      </router-link>

      <!-- Sub Menu -->
      <TransitionExpand v-if="subMenu">
        <ul v-if="checkIfOpen()">
          <li>
            <router-link
              v-if="showOverviewPage"
              :to="path"
              :class="[`level-${level + 1}`, { active: isExact }]"
            >
              Overview
            </router-link>
          </li>

          <li v-for="subMenuItem in subMenu" :key="subMenuItem.sys.id">
            <MenuItem :parent-path="path" :item="subMenuItem" :level="level + 1" />
          </li>
        </ul>
      </TransitionExpand>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.level-0 {
  @include menu-item-level-0;
  width: 100%;
  border: 0;
  background: 0;
}

.level-1 {
  @include menu-item-level-1;
}

.level-2 {
  @include menu-item-level-2;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
